import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import _ from "lodash";
import React, { useState } from "react";

dayjs.extend(isBetween);

export const Schedule = ({ campaigns }) => {
  const [expandedHours, setExpandedHours] = useState({});

  const generateTimeSlots = () => {
    return _.chain()
      .thru(() => {
        return _.range(24);
      })
      .flatMap((i) => {
        const hour = _.padStart(i, 2, "0");
        return [
          `${hour}:00`,
          `${hour}:10`,
          `${hour}:20`,
          `${hour}:30`,
          `${hour}:40`,
          `${hour}:50`,
        ];
      })
      .value();
  };

  const isCampaignActiveInSlot = (campaign, slot) => {
    const [startHour, startMinute] = campaign.start_time.split(":").map(Number);
    const [endHour, endMinute] = campaign.end_time.split(":").map(Number);
    const [slotHour, slotMinute] = slot.split(":").map(Number);

    const startTime = dayjs().set("hour", startHour).set("minute", startMinute);
    const endTime = dayjs().set("hour", endHour).set("minute", endMinute);
    const slotTime = dayjs().set("hour", slotHour).set("minute", slotMinute);

    return (
      (slotTime.isSame(startTime) || slotTime.isAfter(startTime)) &&
      (slotTime.isBefore(endTime) || slotTime.isSame(endTime))
    );
  };

  const timeSlots = generateTimeSlots();
  const groupedTimeSlots = _.groupBy(timeSlots, (slot) => slot.split(":")[0]);

  const toggleHour = (hour) => {
    setExpandedHours((prev) => ({
      ...prev,
      [hour]: !prev[hour],
    }));
  };

  return (
    <div>
      <div>============================================</div>
      <div>Playback Schedule</div>
      <table>
        <thead>
          <tr>
            <th>Time Slot</th>
            <th>Active Campaigns</th>
          </tr>
        </thead>
        <tbody>
          {_.map(groupedTimeSlots, (slots, hour) => (
            <React.Fragment key={hour}>
              <tr onClick={() => toggleHour(hour)}>
                <td>{hour}:00</td>
                <td>
                  {slots.some((slot) =>
                    campaigns.some((campaign) =>
                      isCampaignActiveInSlot(campaign, slot)
                    )
                  )}
                </td>
              </tr>
              {expandedHours[hour] &&
                _.map(slots, (slot) => (
                  <tr key={slot}>
                    <td>{slot}</td>
                    <td>
                      {campaigns
                        .filter((campaign) =>
                          isCampaignActiveInSlot(campaign, slot)
                        )
                        .map((campaign) => campaign.name)
                        .join(", ")}
                    </td>
                  </tr>
                ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};
